import React from 'react';
import { useState } from 'react';

export const FixtureProduct = ({product}) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }

  return (
    <div className="col-md-4 col-sm-6 px-3 mb-5" onClick={handleClick}>
      <div className="product-card product-card-2 border h-100">
        <div className="px-1 h-100 d-flex flex-column">
          <div className="image px-3 pt-3 flex-grow-1 d-flex align-items-center justify-content-center">
            <img src={product.image} alt="" className="img-fluid mw-100 mh-100 border" />
          </div>
          <div className="description px-3 py-3">
            <p className="product-name">{product.name}</p>
            <div className="d-flex justify-content-between">
              <span />
              <div class="checkbox-container">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div>            
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export const FixtureSystem = ({ imageUrl, label, showCheckbox }) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }


  return (
    <div className="product-card product-card-2 border h-100" onClick={handleClick}>
      <div className="px-1 h-100 d-flex flex-column">
        <div className="image px-3 pt-3 flex-grow-1 d-flex align-items-center justify-content-center">
          <img src={imageUrl} alt="" className='img-fluid mw-100 mh-100'/>
        </div>
        <div className="description px-3">
          <p className="product-name">{label}</p>
          <div className="py-3 d-flex justify-content-between">
            <span />
            {showCheckbox && <div class="checkbox-container">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};
